<ng-container *ngrxLet="command() as currentCommand">
    <div class="st-insert-take-command-dialog__line">
        <st-combo-box
            st-click-stop-propagation
            shouldHaveFilter="false"
            [addEmptyOption]="false"
            [value]="getCurrentCommandValue()"
            [label]="languageSettings()?.[ProductionCommandFieldsLabelKeys[ProductionFieldName.OPTION]]"
            [itemList]="productionCommandsObjectOptions"
            (changed)="onCommandsObjectChange($event, ProductionFieldName.OPTION)" />
        <st-text-field
            showLinks
            [value]="currentCommand[ProductionFieldName.OPTION_DESCRIPTION]"
            [label]="languageSettings()?.[getCurrentCommandValue().id]"
            (enter)="saveCommand($event, ProductionFieldName.OPTION_DESCRIPTION)"
            (changed)="onCommandsObjectChange($event, ProductionFieldName.OPTION_DESCRIPTION)" />
    </div>
    <st-text-field
        showLinks
        [value]="currentCommand[ProductionFieldName.NAME]"
        [label]="languageSettings()?.[ProductionCommandFieldsLabelKeys[ProductionFieldName.NAME]]"
        (enter)="saveCommand($event, ProductionFieldName.NAME)"
        (changed)="onCommandsObjectChange($event, ProductionFieldName.NAME)" />
    <st-text-field
        showLinks
        [value]="currentCommand[ProductionFieldName.NUMBER]"
        [label]="languageSettings()?.[ProductionCommandFieldsLabelKeys[ProductionFieldName.NUMBER]]"
        (enter)="saveCommand($event, ProductionFieldName.NUMBER)"
        (changed)="onCommandsObjectChange($event, ProductionFieldName.NUMBER)" />
    <st-text-field
        showLinks
        [value]="currentCommand[ProductionFieldName.INCUE]"
        [label]="languageSettings()?.[ProductionCommandFieldsLabelKeys[ProductionFieldName.INCUE]]"
        (enter)="saveCommand($event, ProductionFieldName.INCUE)"
        (changed)="onCommandsObjectChange($event, ProductionFieldName.INCUE)" />
    <st-text-field
        showLinks
        [value]="currentCommand[ProductionFieldName.OUTCUE]"
        [label]="languageSettings()?.[ProductionCommandFieldsLabelKeys[ProductionFieldName.OUTCUE]]"
        (enter)="saveCommand($event, ProductionFieldName.OUTCUE)"
        (changed)="onCommandsObjectChange($event, ProductionFieldName.OUTCUE)" />

    <div class="st-insert-take-command-dialog__at-to">
        <st-duration-seconds-input-field
            showLinks
            [label]="languageSettings()?.[ProductionCommandFieldsLabelKeys[ProductionFieldName.AT]]"
            [value]="currentCommand[ProductionFieldName.AT]"
            (enter)="saveCommand($event, ProductionFieldName.AT)"
            (changed)="onCommandsObjectChange($event, ProductionFieldName.AT)" />
        <st-duration-seconds-input-field
            showLinks
            [label]="languageSettings()?.[ProductionCommandFieldsLabelKeys[ProductionFieldName.TO]]"
            [value]="currentCommand[ProductionFieldName.TO]"
            (enter)="saveCommand($event, ProductionFieldName.TO)"
            (changed)="onCommandsObjectChange($event, ProductionFieldName.TO)" />
    </div>

    <div class="st-insert-take-command-dialog__type-content">
        <mat-radio-group
            class="st-insert-take-command-dialog__type-content__radio-group"
            [value]="currentCommand[ProductionFieldName.TIME_FIELD]"
            (keyup)="onKeyup($event, ProductionFieldName.TIME_FIELD)"
            (change)="onCommandsObjectChange($event?.value, ProductionFieldName.TIME_FIELD)">
            <mat-radio-button [value]="ProductionFieldName.DURATION">{{ languageSettings()?.[ProductionCommandFieldsLabelKeys[ProductionFieldName.DURATION]] }}</mat-radio-button>
            <mat-radio-button [value]="ProductionFieldName.ITEM_TIME">{{ languageSettings()?.[ProductionCommandFieldsLabelKeys[ProductionFieldName.ITEM_TIME]] }}</mat-radio-button>
        </mat-radio-group>

        <st-duration-seconds-input-field
            [placeholder]="languageSettings()?.[ProductionCommandFieldsLabelKeys[ProductionFieldName.DURATION]]"
            [value]="currentCommand[ProductionFieldName.TIME_VALUE]"
            (enter)="saveCommand($event, ProductionFieldName.TIME_VALUE)"
            (changed)="onCommandsObjectChange($event, ProductionFieldName.TIME_VALUE)" />
    </div>
</ng-container>
